import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { RootState } from "../../../store-types";
import { IObservationEditingState } from "../shared/interfaces/types";

import { OBSERVATION_EDITING_MODULE_NAME } from "./constants";

export const getObservationEditingState = (
  rootState: RootState
): IObservationEditingState => rootState[OBSERVATION_EDITING_MODULE_NAME];

export const getIsLoading = createDraftSafeSelector(
  getObservationEditingState,
  (state: IObservationEditingState) => state.isLoading
);

export const getExistingPhotosList = createDraftSafeSelector(
  getObservationEditingState,
  (state: IObservationEditingState) => state.existingPhotos
);

export const getPhotoFilesList = createDraftSafeSelector(
  getObservationEditingState,
  (state: IObservationEditingState) => state.photoFiles
);
